import http from "./httpService";

export function login(email, password) {
  return http.post(`${process.env.REACT_APP_API}/users/login`, {
    email: email,
    password: password,
  });
}
